<div class="p-4 md:p-6 max-w-full mx-auto">
  <!-- Header -->
  <div class="flex items-center gap-3 mb-6">
    <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">history</mat-icon>
    <h1 class="text-xl md:text-2xl font-bold text-gray-800">Mis Conexiones</h1>
  </div>

  <!-- Error -->
  <div *ngIf="errorMessage" class="error-snackbar mb-4">
    <mat-icon>error</mat-icon>
    <span>{{ errorMessage }}</span>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="flex justify-center items-center p-8">
    <mat-spinner diameter="40"></mat-spinner>
    <span class="ml-3 text-gray-600">Cargando historial...</span>
  </div>

  <!-- Results -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden" *ngIf="!loading && records.length > 0">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
        <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">devices</mat-icon>
          Historial de Sesiones
        </h2>
        <span class="text-xs text-gray-600" *ngIf="pagination.total > 0">
          {{ (pagination.page - 1) * pagination.limit + 1 }} -
          {{ Math.min(pagination.page * pagination.limit, pagination.total) }}
          de {{ pagination.total }}
        </span>
      </div>
    </div>

    <!-- Cards -->
    <div class="space-y-3 p-4">
      <div *ngFor="let record of records; let i = index"
        class="bg-white rounded-xl shadow-sm border overflow-hidden transition-all duration-200"
        [style.borderColor]="expandedCardId === i ? '#1C593D' : '#e5e7eb'">

        <!-- Card header -->
        <div class="flex items-center justify-between p-3 cursor-pointer"
          (click)="toggleCard(i)"
          [style.background]="expandedCardId === i ? '#f0fdf4' : 'white'">
          <div class="flex items-center gap-2 flex-1 min-w-0">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D;">calendar_today</mat-icon>
            <span class="text-sm font-semibold text-gray-800">{{ formatDate(record.date) }}</span>
          </div>
          <div class="flex items-center gap-2">
            <span class="text-xs font-bold px-2 py-0.5 rounded-full" style="background: #f0fdf4; color: #1C593D;">
              {{ record.connectionCount }} conexiones
            </span>
            <mat-icon class="text-gray-400 shrink-0 transition-transform duration-200"
              [style.transform]="expandedCardId === i ? 'rotate(180deg)' : 'rotate(0)'">
              expand_more
            </mat-icon>
          </div>
        </div>

        <!-- Card body -->
        <div *ngIf="expandedCardId === i" class="px-3 pb-3 border-t border-gray-100">
          <div class="grid grid-cols-2 gap-2 mt-3 text-xs">
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Primera Conexi&oacute;n</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ formatTime(record.firstConnectionAt) }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">&Uacute;ltima Conexi&oacute;n</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ formatTime(record.lastConnectionAt) }}</p>
            </div>
          </div>

          <!-- Connection details -->
          <div class="mt-3 pt-3 border-t border-gray-100" *ngIf="record.connectionDetails?.length">
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Dispositivos</span>
            <div class="space-y-2 mt-2">
              <div *ngFor="let conn of record.connectionDetails"
                class="flex items-center gap-2 text-xs"
                style="background: #f9fafb; padding: 6px 8px; border-radius: 8px;">
                <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #6b7280;">{{ getDeviceIcon(conn.deviceType) }}</mat-icon>
                <span style="color: #374151;">{{ conn.browser }} &middot; {{ conn.os }}</span>
                <span style="color: #9ca3af;">{{ conn.country }}</span>
                <span style="color: #9ca3af; margin-left: auto;">{{ formatTime(conn.connectedAt) }}</span>
              </div>
            </div>
          </div>

          <!-- View detail button -->
          <div style="display: flex; gap: 8px; margin-top: 12px;">
            <button (click)="viewDetail(record); $event.stopPropagation()"
              style="display: flex; align-items: center; gap: 6px; padding: 8px 14px; background: #1C593D; color: white; border: none; border-radius: 8px; font-size: 0.8rem; font-weight: 600; cursor: pointer; flex: 1; justify-content: center;"
              onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px;">visibility</mat-icon>
              Ver detalle completo
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Paginación -->
    <div class="p-4">
      <mat-paginator
        [length]="pagination.total"
        [pageSize]="pagination.limit"
        [pageIndex]="pagination.page - 1"
        [pageSizeOptions]="pageSizeOptions"
        (page)="onPaginatorChange($event)"
        showFirstLastButtons>
      </mat-paginator>
    </div>
  </div>

  <!-- Sin datos -->
  <div *ngIf="!loading && records.length === 0"
    class="bg-white rounded-2xl shadow-md border border-gray-100 text-center py-8">
    <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #d1d5db;">history</mat-icon>
    <p class="text-lg font-medium text-gray-500 mt-2">Sin registros de conexiones</p>
    <p class="text-sm text-gray-400">Tu historial de conexiones aparecer&aacute; aqu&iacute;</p>
  </div>
</div>
